import type { LocaleMessageBundle } from '../../types'

export const priceMessages: LocaleMessageBundle = {
  vi: {
    'price.priceList.placeholders.code': 'Tự động tạo',
    'price.priceList.placeholders.name': 'Nhập tên bảng giá',
    'price.priceList.placeholders.description': 'Nhập mô tả (không bắt buộc)',
    'price.priceList.placeholders.branches': 'Chọn chi nhánh',
    'price.priceList.title': 'Bảng giá sản phẩm',
    'price.priceList.actions.create': 'Thêm bảng giá',
    'price.priceList.actions.edit': 'Cập nhật bảng giá',
    'price.priceList.actions.delete': 'Xóa bảng giá',
    'price.priceList.actions.removeProduct': 'Bỏ sản phẩm',
    'price.priceList.actions.addUnit': 'Thêm đơn vị',
    'price.priceList.filters.status': 'Trạng thái',
    'price.priceList.fields.code': 'Mã bảng giá',
    'price.priceList.fields.name': 'Tên bảng giá',
    'price.priceList.fields.description': 'Mô tả',
    'price.priceList.fields.priority': 'Độ ưu tiên',
    'price.priceList.fields.default': 'Bảng giá mặc định',
    'price.priceList.fields.validity': 'Hiệu lực',
    'price.priceList.fields.scope': 'Phạm vi',
    'price.priceList.fields.itemsCount': 'Số sản phẩm',
    'price.priceList.fields.updatedAt': 'Cập nhật',
    'price.priceList.fields.formulaType': 'Công thức',
    'price.priceList.fields.formulaValue': 'Giá trị công thức',
    'price.priceList.fields.formulaValueHints.fixed':
      'Nhập giá bán cố định áp dụng cho sản phẩm. Ví dụ: 18000 → tất cả SP được chọn có giá 18.000đ.',
    'price.priceList.fields.formulaValueHints.increase_percent':
      'Nhập % tăng so với giá mặc định. Ví dụ: 10 → giá mới = giá mặc định + 10%.',
    'price.priceList.fields.formulaValueHints.decrease_percent':
      'Nhập % giảm so với giá mặc định. Ví dụ: 20 → giá mới = giá mặc định − 20%.',
    'price.priceList.fields.formulaValueHints.increase_amount':
      'Nhập số tiền cộng thêm. Ví dụ: 2000 → giá mới = giá mặc định + 2.000đ.',
    'price.priceList.fields.formulaValueHints.decrease_amount':
      'Nhập số tiền trừ đi. Ví dụ: 1500 → giá mới = giá mặc định − 1.500đ.',
    'price.priceList.fields.formulaValueHints.multiply':
      'Nhập hệ số nhân. Ví dụ: 1.1 → giá mới = giá mặc định × 1.1.',
    'price.priceList.fields.roundingPrecision': 'Bước làm tròn',
    'price.priceList.fields.roundingMode': 'Kiểu làm tròn',
    'price.priceList.fields.allowMissingProducts': 'Tự tính sản phẩm chưa khai báo',
    'price.priceList.fields.productType': 'Loại sản phẩm',
    'price.priceList.fields.filterGroup': 'Lọc nhóm',
    'price.priceList.fields.filterBrand': 'Lọc thương hiệu',
    'price.priceList.fields.startAt': 'Bắt đầu',
    'price.priceList.fields.endAt': 'Kết thúc',
    'price.priceList.fields.startTime': 'Giờ bắt đầu',
    'price.priceList.fields.endTime': 'Giờ kết thúc',
    'price.priceList.fields.daysOfWeek': 'Ngày áp dụng',
    'price.priceList.fields.branches': 'Chi nhánh',
    'price.priceList.fields.staffs': 'Nhân viên',
    'price.priceList.fields.customerGroups': 'Nhóm khách hàng',
    'price.priceList.fields.areas': 'Khu vực',
    'price.priceList.fields.tables': 'Bàn',
    'price.priceList.fields.products': 'Sản phẩm',
    'price.priceList.fields.product': 'Sản phẩm',
    'price.priceList.fields.productPrice': 'Giá theo bảng giá',
    'price.priceList.fields.basePrice': 'Giá mặc định',
    'price.priceList.fields.unit': 'Đơn vị tính',
    'price.priceList.fields.baseUnit': 'Đơn vị mặc định',
    'price.priceList.fields.priceDiff': 'Chênh lệch',
    'price.priceList.fields.productScope': 'Phạm vi sản phẩm',
    'price.priceList.fields.productScopeIds': 'Lựa chọn phạm vi',
    'price.priceList.fields.applicationMode': 'Cách áp dụng',
    'price.priceList.fields.autoAddProduct': 'Tự động áp dụng cho sản phẩm mới',
    'price.priceList.fields.groups': 'Nhóm sản phẩm',
    'price.priceList.fields.brands': 'Thương hiệu',
    'price.priceList.fields.latestCost': 'Giá nhập gần nhất',
    'price.priceList.sections.general': 'Thông tin chung',
    'price.priceList.sections.formula': 'Quy tắc tính giá',
    'price.priceList.sections.schedule': 'Thời gian áp dụng',
    'price.priceList.sections.scope': 'Phạm vi áp dụng',
    'price.priceList.sections.products': 'Danh sách sản phẩm',
    'price.priceList.messages.deleteConfirm': 'Bạn có chắc muốn xóa bảng giá này?',
    'price.priceList.errors.saveFailed': 'Không thể lưu bảng giá',
    'price.priceList.errors.productsRequired': 'Cần chọn ít nhất một sản phẩm.',
    'price.priceList.errors.scopeIdsRequired': 'Cần chọn ít nhất một nhóm hoặc thương hiệu.',
    'price.priceList.scope.all': 'Tất cả',
    'price.priceList.productScopes.all': 'Toàn bộ sản phẩm',
    'price.priceList.productScopes.products': 'Theo sản phẩm',
    'price.priceList.productScopes.groups': 'Theo nhóm sản phẩm',
    'price.priceList.productScopes.brands': 'Theo thương hiệu',
    'price.priceList.applicationModes.auto': 'Tự động áp dụng',
    'price.priceList.applicationModes.manual': 'Chọn khi bán hàng',
    'price.priceList.statuses.active': 'Hoạt động',
    'price.priceList.statuses.disabled': 'Tạm ngưng',
    'price.priceList.formulas.fixed': 'Giá cố định',
    'price.priceList.formulas.increasePercent': 'Tăng theo phần trăm',
    'price.priceList.formulas.decreasePercent': 'Giảm theo phần trăm',
    'price.priceList.formulas.increaseAmount': 'Tăng theo số tiền',
    'price.priceList.formulas.decreaseAmount': 'Giảm theo số tiền',
    'price.priceList.formulas.multiply': 'Nhân hệ số',
    'price.priceList.rounding.round': 'Làm tròn gần nhất',
    'price.priceList.rounding.ceil': 'Làm tròn lên',
    'price.priceList.rounding.floor': 'Làm tròn xuống',
    'price.priceList.days.monday': 'Thứ hai',
    'price.priceList.days.tuesday': 'Thứ ba',
    'price.priceList.days.wednesday': 'Thứ tư',
    'price.priceList.days.thursday': 'Thứ năm',
    'price.priceList.days.friday': 'Thứ sáu',
    'price.priceList.days.saturday': 'Thứ bảy',
    'price.priceList.days.sunday': 'Chủ nhật',
    'price.priceList.priorityHint': 'Số càng nhỏ, độ ưu tiên càng cao',
    'price.priceList.products.empty': 'Chưa có sản phẩm nào',
    'price.priceList.products.total': 'Tổng số sản phẩm: {count}',
    'price.priceList.products.addAll': 'Thêm toàn bộ sản phẩm',
    'price.priceList.products.removeAll': 'Xóa toàn bộ sản phẩm',
    'price.priceList.products.search': 'Tìm kiếm sản phẩm...',
    'price.priceList.groups.search': 'Tìm kiếm nhóm sản phẩm...',
    'price.priceList.brands.search': 'Tìm kiếm thương hiệu...',
    'price.priceList.scopeItems.allNotice': 'Áp dụng cho tất cả sản phẩm trong hệ thống.',
    'price.priceList.scopeItems.empty': 'Chưa chọn mục nào.',
    'price.priceList.scopeItems.total': 'Tổng: {count}',
    'price.priceList.statuses.expired': 'Hết hạn',
  },
  en: {
    'price.priceList.placeholders.code': 'Auto-generated',
    'price.priceList.placeholders.name': 'Enter price list name',
    'price.priceList.placeholders.description': 'Enter description (optional)',
    'price.priceList.placeholders.branches': 'Select branches',
    'price.priceList.title': 'Price lists',
    'price.priceList.actions.create': 'Create price list',
    'price.priceList.actions.edit': 'Edit price list',
    'price.priceList.actions.delete': 'Delete price list',
    'price.priceList.actions.removeProduct': 'Remove product',
    'price.priceList.actions.addUnit': 'Add unit',
    'price.priceList.filters.status': 'Status',
    'price.priceList.fields.code': 'Code',
    'price.priceList.fields.name': 'Name',
    'price.priceList.fields.description': 'Description',
    'price.priceList.fields.priority': 'Priority',
    'price.priceList.fields.default': 'Default price list',
    'price.priceList.fields.validity': 'Validity',
    'price.priceList.fields.scope': 'Scope',
    'price.priceList.fields.itemsCount': 'Products',
    'price.priceList.fields.updatedAt': 'Updated',
    'price.priceList.fields.formulaType': 'Formula',
    'price.priceList.fields.formulaValue': 'Formula value',
    'price.priceList.fields.formulaValueHints.fixed':
      'Enter a fixed sale price. Example: 18000 → selected products sell at 18,000.',
    'price.priceList.fields.formulaValueHints.increase_percent':
      'Enter the percent to increase from base price. Example: 10 → base + 10%.',
    'price.priceList.fields.formulaValueHints.decrease_percent':
      'Enter the percent to decrease from base price. Example: 20 → base − 20%.',
    'price.priceList.fields.formulaValueHints.increase_amount':
      'Enter the amount to add. Example: 2000 → base + 2,000.',
    'price.priceList.fields.formulaValueHints.decrease_amount':
      'Enter the amount to subtract. Example: 1500 → base − 1,500.',
    'price.priceList.fields.formulaValueHints.multiply':
      'Enter a multiplier. Example: 1.1 → base × 1.1.',
    'price.priceList.fields.roundingPrecision': 'Rounding step',
    'price.priceList.fields.roundingMode': 'Rounding mode',
    'price.priceList.fields.allowMissingProducts': 'Auto-price missing products',
    'price.priceList.fields.productType': 'Product type',
    'price.priceList.fields.filterGroup': 'Filter group',
    'price.priceList.fields.filterBrand': 'Filter brand',
    'price.priceList.fields.startAt': 'Start',
    'price.priceList.fields.endAt': 'End',
    'price.priceList.fields.startTime': 'Start time',
    'price.priceList.fields.endTime': 'End time',
    'price.priceList.fields.daysOfWeek': 'Days of week',
    'price.priceList.fields.branches': 'Branches',
    'price.priceList.fields.staffs': 'Staff',
    'price.priceList.fields.customerGroups': 'Customer groups',
    'price.priceList.fields.areas': 'Areas',
    'price.priceList.fields.tables': 'Tables',
    'price.priceList.fields.products': 'Products',
    'price.priceList.fields.product': 'Product',
    'price.priceList.fields.productPrice': 'Price list price',
    'price.priceList.fields.basePrice': 'Base price',
    'price.priceList.fields.unit': 'Unit',
    'price.priceList.fields.baseUnit': 'Default unit',
    'price.priceList.fields.priceDiff': 'Difference',
    'price.priceList.fields.productScope': 'Product scope',
    'price.priceList.fields.productScopeIds': 'Scope selection',
    'price.priceList.fields.applicationMode': 'Application mode',
    'price.priceList.fields.autoAddProduct': 'Auto-apply to newly created products',
    'price.priceList.fields.groups': 'Product groups',
    'price.priceList.fields.brands': 'Brands',
    'price.priceList.fields.latestCost': 'Latest cost',
    'price.priceList.sections.general': 'General',
    'price.priceList.sections.formula': 'Pricing rules',
    'price.priceList.sections.schedule': 'Schedule',
    'price.priceList.sections.scope': 'Scope',
    'price.priceList.sections.products': 'Products',
    'price.priceList.messages.deleteConfirm': 'Delete this price list?',
    'price.priceList.errors.saveFailed': 'Unable to save price list',
    'price.priceList.errors.productsRequired': 'Select at least one product.',
    'price.priceList.errors.scopeIdsRequired': 'Select at least one group or brand.',
    'price.priceList.scope.all': 'All',
    'price.priceList.productScopes.all': 'All products',
    'price.priceList.productScopes.products': 'By products',
    'price.priceList.productScopes.groups': 'By product groups',
    'price.priceList.productScopes.brands': 'By brands',
    'price.priceList.applicationModes.auto': 'Apply automatically',
    'price.priceList.applicationModes.manual': 'Select when selling',
    'price.priceList.statuses.active': 'Active',
    'price.priceList.statuses.disabled': 'Inactive',
    'price.priceList.formulas.fixed': 'Fixed price',
    'price.priceList.formulas.increasePercent': 'Increase by percent',
    'price.priceList.formulas.decreasePercent': 'Decrease by percent',
    'price.priceList.formulas.increaseAmount': 'Increase by amount',
    'price.priceList.formulas.decreaseAmount': 'Decrease by amount',
    'price.priceList.formulas.multiply': 'Multiply',
    'price.priceList.rounding.round': 'Round nearest',
    'price.priceList.rounding.ceil': 'Round up',
    'price.priceList.rounding.floor': 'Round down',
    'price.priceList.days.monday': 'Monday',
    'price.priceList.days.tuesday': 'Tuesday',
    'price.priceList.days.wednesday': 'Wednesday',
    'price.priceList.days.thursday': 'Thursday',
    'price.priceList.days.friday': 'Friday',
    'price.priceList.days.saturday': 'Saturday',
    'price.priceList.days.sunday': 'Sunday',
    'price.priceList.priorityHint': 'Lower number means higher priority',
    'price.priceList.products.empty': 'No products yet',
    'price.priceList.products.total': 'Total products: {count}',
    'price.priceList.products.addAll': 'Add all products',
    'price.priceList.products.removeAll': 'Remove all products',
    'price.priceList.products.search': 'Search products...',
    'price.priceList.groups.search': 'Search product groups...',
    'price.priceList.brands.search': 'Search brands...',
    'price.priceList.scopeItems.allNotice': 'Applies to all products in the system.',
    'price.priceList.scopeItems.empty': 'No items selected yet.',
    'price.priceList.scopeItems.total': 'Total: {count}',
    'price.priceList.statuses.expired': 'Expired',
  },
}
